import type { CardAddons } from '@/pages/booking-funnel/packageConfiguration/types/packageData'

// file copied from createBooking.ts, will need to be adapted

// TODO: this was copied from SDK
// needs to be adapted in SDK
// TODO:  \\--> Antoine answer: As requested, the SDK has been update and the below fields are useless (bc not interpreted by the proxy):
//      "patternDay" & "functionRoomSetupName" & "rental" & "startTime" & "endTime"
export interface RequestPaymentPrices {
  packages: {
    id: string
    days: {
      patternDay?: number
      attendees: number
      functionRoomId: string
      functionRoomSetupName: string
      events: {
        eventClassificationId: string
        rental?: number
        startTime: string
        endTime: string
        addOnItems: {
          id: string
          quantity: number
        }[]
      }[]
    }[]
  }[]
}

export function createRequestPricingObject(params: {
  packageId: string
  attendees: number
  functionRoomId: string
  functionRoomSetupName: string
  functionRoomEvents: {
    id: string
    eventClassificationId: string
  }[]
  selectedAddons?: CardAddons
}): RequestPaymentPrices {
  return {
    packages: [
      {
        id: params.packageId,
        days: [
          {
            patternDay: 0, // Antoine: this is Useless
            attendees: params.attendees,
            functionRoomId: params.functionRoomId,
            functionRoomSetupName: params.functionRoomSetupName, // Antoine: this is Useless
            events: params.functionRoomEvents.map((event) => {
              const addons = []
              const matchingAddons = params.selectedAddons?.[event.id]
              if (matchingAddons) {
                addons.push(
                  ...matchingAddons.map((addon) => {
                    return {
                      id: addon.addonId,
                      quantity: addon.quantity,
                    }
                  }),
                )
              }
              return {
                eventClassificationId: event.eventClassificationId,
                startTime: '', // need to check with sdk if really necessary => Antoine: No, it's not used
                endTime: '', // need to check with sdk if really necessary => Antoine: No, it's not used
                addOnItems: addons,
              }
            }),
          },
        ],
      },
    ],
  }
}
